import CoreMenuInfoPage from 'src/dispensary/core-menu/info';

export default CoreMenuInfoPage;
